import React from 'react';
import Tooltip from './Styled/StyledEllipsisTooltip';
import EllipsisCell from './Styled/StyledEllipsisCell';

export default ({ text }) => (
  <Tooltip title={text}>
    <EllipsisCell>{text}</EllipsisCell>
  </Tooltip>
);
